import moment from 'moment-timezone';
export const areTimesEqual = (timeA, timeB) => {
    if (!timeA || !timeB)
        return timeA === timeB;
    if (!moment.isMoment(timeA) && !moment.isMoment(timeB))
        return timeA === timeB;
    if (!moment.isMoment(timeA) || !moment.isMoment(timeB))
        return false;
    return timeA.isSame(timeB);
};
const getLocalTimeIfNecessary = m => (m?.isValid() ? m : moment());
export const calcTimeRemaining = (currentServerTime, endTime) => endTime.diff(getLocalTimeIfNecessary(currentServerTime), 'milliseconds');
//# sourceMappingURL=utils.js.map